import BrowserSupportIpcRouter, { BrowserSupportIpcRouterType } from '@shared/ipc/routers/BrowserSupportIpc.router'

class BrowserSupportIpcRenderer extends BrowserSupportIpcRouter implements BrowserSupportIpcRouterType {
  async getTabs() {
    return this.exec('getTabs')
  }
  async getBrowserTabContext(tabId: number) {
    return this.exec('getBrowserTabContext', { tabId })
  }
}

export default new BrowserSupportIpcRenderer()
